import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Btns, ButtonL } from "../styles/Common";
import { styled } from "styled-components";
import homeBg from "../styles/images/home.svg";

const StartPage = () => {
  let navigate = useNavigate();

  return (
    <PullLayout>
      <PullPageBtns>
        <ButtonL
          onClick={() => {
            navigate("/home");
          }}
        >
          시작하기
        </ButtonL>
      </PullPageBtns>
    </PullLayout>
  );
};

export default StartPage;

const PullLayout = styled.div`
  background-image: url(${homeBg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  position: relative;
`;

const PullPageBtns = styled(Btns)`
  position: absolute;
  bottom: 0;
  width: 100%;
`;
